import "../Styles/Qr.css";

import {
  FaInstagram,

  FaWhatsapp,

  FaGoogle,

} from "react-icons/fa";
import { useState, useEffect } from "react";
import api from "./Api";
import { useParams } from "react-router-dom";


export default function QrPage() {
    const [business, setBusiness] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showStandPreview, setShowStandPreview] = useState(false);
    const [error, setError] = useState("");
    const { slug } = useParams();

     useEffect(() => {
        const fetchBusiness = async () => {
          try {
            setLoading(true);
            setError("");
    
            const res = await api.get(`/get-business/${slug}`);
    
            setBusiness(res.data.business);
          } catch (err) {
            setError(err.response?.data?.message || "Business not found");
            console.log(error);
          } finally {
            setLoading(false);
          }
        };
  

        if (slug) {
          fetchBusiness();
        }
      }, [slug,error]);
return (
  <div>
    {loading ? (
      <div className="demo-container">
    <div className="phone-wrapper">
      <div className="phone">
        <div className="phone-top" />

        {/* HEADER SKELETON */}
        <div className="customer-header">
          <div className="skeleton-avatar" />

          <div className="skeleton-line short" />
          <div className="skeleton-line long" />

          <div className="about-card">
            <div className="skeleton-line full" />
            <div className="skeleton-line full" />
          </div>
        </div>

        {/* BUTTONS SKELETON */}
        <div className="link-buttons">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="skeleton-button" />
          ))}
        </div>
      </div>
    </div>
  </div>
    ) : (
      <>
        <div className="demo-container">
          {/* BUSINESS DISPLAY */}
          <div className="business-side">
            <div className="business-card">
              <div className="glow" />

              <img
                src={business?.logoUrl}
                alt="logo"
                className="business-logo"
              />

              <h1>{business?.businessName}</h1>

              <p>
                Scan to leave a review, follow us or contact us instantly.
              </p>

              <div className="qr-box">
                <img
                  src={business?.qrCodeUrl}
                  alt="qr-code"
                  className="qr-image"
                />
              </div>

              <div className="tag-row">
                <span>
                  <FaGoogle />
                  Reviews
                </span>

                <span>
                  <FaInstagram />
                  Socials
                </span>

                <span>
                  <FaWhatsapp />
                  Contact
                </span>
              </div>

              <div className="powered-by">
                <span>Powered by</span>

                <a
                  href="https://www.clusterclear.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  ClusterClear
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ACTION BUTTONS (outside demo but inside main render) */}
        <div className="action-buttons">
          <button onClick={() => window.print()} className="btn">
            Print QR Stand for free
          </button>

          <button
            onClick={() => setShowStandPreview(true)}
            className="btn secondary"
          >
            Request Professional Stand
          </button>

        </div>
      </>
    )}

    {/* MODAL (must always be outside loading logic) */}
    {showStandPreview && (
      <div
        className="modal-overlay"
        onClick={() => setShowStandPreview(false)}
      >
        <div
          className="stand-preview-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <h3>How your stand will look</h3>

       <div style={{ position: "relative", width: "100%" }}>
  <img
    src="https://i.etsystatic.com/32360739/r/il/dba415/7308830662/il_794xN.7308830662_did9.jpg"
    alt="Professional QR Stand Preview"
    className="stand-preview-image"
    style={{ objectFit: "contain", width: "100%" }}
  />

  <div
    style={{
      position: "absolute",
      top: "15px",
      right: "15px",
      background: "#000",
      color: "#fff",
      padding: "8px 16px",
      borderRadius: "20px",
      fontWeight: "bold",
      fontSize: "16px",
    }}
  >
    £35
  </div>
</div>

          <p className="preview-note">
            This is a real example of how your printed stand will look.
          </p>

          <button
            className="btn primary"
            onClick={() => {
              const message = encodeURIComponent(
                `Hi, I want to order a QR stand for ${business?.businessName}`
              );

              window.open(
                `https://wa.me/7547384088?text=${message}`,
                "_blank"
              );
            }}
          >
            Request This Stand
          </button>

          <button
            className="btn secondary"
            onClick={() => setShowStandPreview(false)}
          >
            Close
          </button>
        </div>
      </div>
    )}
  </div>
);
}